import { Tabs as TabsPrimitive } from "radix-ui";
import type { ComponentPropsWithRef } from "react";

import { cx } from "@/lib/cx";

import styles from "./Tabs.module.css";

/** In-page tabs (role=tab). For tabs that change the URL, use router links styled with `tabLinkClass`. */
export const Tabs = TabsPrimitive.Root;

export function TabsList({
  className,
  ...props
}: ComponentPropsWithRef<typeof TabsPrimitive.List>) {
  return <TabsPrimitive.List className={cx(styles.list, className)} {...props} />;
}

export function TabsTrigger({
  className,
  ...props
}: ComponentPropsWithRef<typeof TabsPrimitive.Trigger>) {
  return <TabsPrimitive.Trigger className={cx(styles.tab, className)} {...props} />;
}

export function TabsContent({
  className,
  ...props
}: ComponentPropsWithRef<typeof TabsPrimitive.Content>) {
  return <TabsPrimitive.Content className={cx(styles.content, className)} {...props} />;
}

/** Tab bar and tab styles for route-based tabs (links with aria-current="page"). */
export const tabListClass = styles.list;
export const tabLinkClass = styles.tab;
